import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import { cn } from '@/utils/cn';
import * as React from 'react';

const PhoneInputWithCustomStyles = ({ value, onChange }) => {

  return (
    <PhoneInput
      country={'co'} // Default country
      onlyCountries={['co']}
      value={value}
      placeholder='000 000 0000'
      onChange={onChange}
      inputProps={{
        required: true,
        name: 'phone',
      }}
      disableCountryCode={true} // Prevent user from editing/removing the country code
      buttonClass="!rounded-l-[10px] !px-2 !hover:bg-gray-200 !bg-gray-200" // Match the height and styling of the input
    />
  );
};

export default PhoneInputWithCustomStyles;
